<template>
  <v-container fluid>
    <v-row justify="center" no-gutters>
      <v-col cols="auto">

        <!--        RESTART-->
        <v-btn @click="$emit('reset')"
               :disabled="disabled"
               color="white"
               icon
               class="mr-1"
               title="Restart"
        >
          <v-icon size="22">
            mdi-restore
          </v-icon>
        </v-btn>

        <!--        REWIND 5 SEC-->
        <v-btn @click="$emit('backward')"
               :disabled="disabled || this.progress < 0.5 || (this.progress > 99 && !this.isPlaying)"
               color="white"
               icon
               class="mr-1"
               title="Rewind 5 sec"
        >
<!--          <v-img src="/img/media/rewind_5.png"></v-img>-->
<!--          <v-icon size="28">-->
<!--            mdi-rewind-10-->
<!--          </v-icon>-->

          <v-icon size="13" style="width:13px">
            mdi-minus
          </v-icon>
          <v-icon size="28" style="width:13px">
            mdi-numeric-5
          </v-icon>
        </v-btn>

        <!--        PLAY / PAUSE WITH PROGRESS AROUND-->
        <v-progress-circular v-model="progress" size="50" rotate="270" class="mx-2" :width="disabled ? 0 : 2 ">
          <v-btn @click="$emit('togglePlayPause')"
                 :disabled="disabled"
                 color="white"
                 icon
                 class="mx-2"
                 title="Play / Pause"
          >
            <v-icon size="35">
              {{ playPauseButtonIcon }}
            </v-icon>
          </v-btn>
        </v-progress-circular>

        <!--        FAST FORWARD 5 SEC-->
        <v-btn @click="$emit('forward')"
               :disabled="disabled || this.progress > 99"
               color="white"
               icon
               title="Fast forward 5 sec"
        >
<!--          <v-img src="/img/media/forward_5.png"></v-img>-->
<!--          <v-icon size="28">-->
<!--            mdi-fast-forward-10-->
<!--          </v-icon>-->
          <v-icon size="13" style="width:13px">
           mdi-plus
          </v-icon>
          <v-icon size="28" style="width:13px">
           mdi-numeric-5
          </v-icon>
        </v-btn>

        <!--        TRANSCRIPTION-->
        <v-btn color="white"
               icon
               :disabled="!transcriptionAvailable"
               title="Show transcription"
               v-if="false"
        >
          <v-icon>mdi-subtitles</v-icon>
        </v-btn>

        <!--        CAPTIONS (SUBTITLES)-->
        <v-btn :color="showSubtitles ? 'white' : 'grey'"
               icon
               @click="$emit('toggleSubtitles')"
               :disabled="!subtitlesAvailable"
               title="Show subtitles"
        >
          <v-icon>mdi-closed-caption</v-icon>
        </v-btn>

        <!--        VOLUME MENU-->
        <v-menu offset-y :close-on-content-click="false">
          <template v-slot:activator="{ on }">
            <v-btn color="white"
                   icon
                   v-on="on"
            >
              <v-icon>{{volumeIcon}}</v-icon>
            </v-btn>
          </template>
          <v-card>
            <v-card-text>
              <v-slider
                  color="accent"
                  v-model="volume"
                  @change="setVolume($event)"
                  vertical
              ></v-slider>
            </v-card-text>
          </v-card>
        </v-menu>

      </v-col>
<!--      <v-col cols="auto">-->
<!--        <v-slider-->
<!--            style="width: 150px;"-->
<!--            class="mt-2"-->
<!--            v-model="volume"-->
<!--            @change="$emit('setVolume',volume)"-->
<!--            append-icon="mdi-volume-high"-->
<!--            prepend-icon="mdi-volume-low"-->
<!--            color="accent"-->
<!--            @click:append="volume+=10; $emit('setVolume',volume)"-->
<!--            @click:prepend="volume-=10; $emit('setVolume',volume)"-->
<!--        ></v-slider>-->
<!--      </v-col>-->
    </v-row>
  </v-container>
</template>

<script>
  export default {
    name: "MediaCompositionControls",
    props:{
      showSubtitles: {
        type: Boolean,
        required: true,
      },
      subtitlesAvailable: {
        type: Boolean,
        required: true,
      },
      showTranscription: {
        type: Boolean,
        required: true,
      },
      transcriptionAvailable: {
        type: Boolean,
        required: true,
      },
      mediaReady: {
        type: Boolean,
        default: false,
      },
      isPlaying: {
        type: Boolean,
        default: false,
      },
    },
    data(){
      return {
        volume: 80,
        progress: 100,
      }
    },
    methods:{
      setProgress(progress){
        this.$nextTick(()=>{
          this.progress = progress;
        });
      },
      setVolume(volume){
        this.$emit('setVolume',volume);
      }
    },
    computed: {
      playPauseButtonIcon() {
        return this.isPlaying ? 'mdi-pause' : 'mdi-play'
      },
      volumeIcon() {
        return this.volume <= 0 ? 'mdi-volume-low' : this.volume <= 50 ? 'mdi-volume-medium' : 'mdi-volume-high'
      },
      disabled(){
        return !this.mediaReady;
      },
    },
    beforeDestroy(){
      // window.removeEventListener("keydown",()=>{});
    },
    mounted(){

      // window.addEventListener('keydown', (e) => {
      //
      //   if (this.disabled) return;
      //
      //   if(e.code === 'Space'){
      //     this.$emit('togglePlayPause')
      //   }
      //
      //   if (e.code === 'ArrowRight') {
      //     this.$emit('forward')
      //   }
      //
      //   if (e.code === 'ArrowLeft') {
      //     this.$emit('backward')
      //   }
      // });
    }
  }
</script>

<style scoped>

</style>
